const PluginData = [
  {
    pluginId: 1,
    icon: '/media/plugins/jstree/profileQuestions.jpg',
    name: 'Profile questions and Interest',
    type: 'Software',
    description: 'Customize your users profile with your own custom questions and interest system',
    status: 'Active',
    path: 'question_answer_plugin',
  },
  {
    pluginId: 2,
    icon: '/media/plugins/jstree/gifts.jpg',
    name: 'Gifts',
    type: 'Software',
    description: 'Allow users to send gift eachother',
    status: 'Active',
    path: 'gifts_plugin',
  },
  {
    pluginId: 3,
    icon: '/media/plugins/jstree/chat.jpg',
    name: 'Chat',
    type: 'Pages',
    description: 'Configure the messaging system',
    status: 'Active',
    path: 'chat_plugin',
  },
  {
    pluginId: 4,
    icon: '/media/plugins/jstree/rewards.jpg',
    name: 'Rewards',
    type: 'Software',
    description: 'Give free credits to users after complete some tasks in the site',
    status: 'Active',
    path: 'reward_plugin',
  },
  {
    pluginId: 5,
    icon: '/media/plugins/jstree/credits.jpg',
    name: 'Site pricing',
    type: 'Software',
    description: 'Update the credits and premium pricing details',
    status: 'Active',
    path: 'site_pricing_plugin',
  },
  {
    pluginId: 7,
    icon: '/media/plugins/jstree/populars.jpg',
    name: 'Global Online',
    type: 'Pages',
    description: 'Shows the global online users in the platform',
    status: 'Active',
    path: 'global_online_plugin',
  },
  {
    pluginId: 8,
    icon: '/media/plugins/jstree/spotlight.jpg',
    name: 'Spotlight',
    type: 'Software',
    description: 'Allow users to get into the spotlight and get seen more by others',
    status: 'Active',
    path: 'spotlight_plugin',
  },
  {
    pluginId: 11,
    icon: '/media/plugins/jstree/settings.jpg',
    name: 'General Settings',
    type: 'Software',
    description: 'Software general settings',
    status: 'Active',
    path: 'general_plugin',
  },
  {
    pluginId: 12,
    icon: '/media/plugins/jstree/verification.jpg',
    name: 'Verification system',
    type: 'Software',
    description: 'Allow users to verify their profile by copying a gesture',
    status: 'Active',
    path: 'verification_system_plugin',
  },
  {
    pluginId: 13,
    icon: '/media/plugins/jstree/terms.jpg',
    name: 'Legal information',
    type: 'Pages',
    description: 'Edit your site terms of use, privacy policy and cookies',
    status: 'Active',
    path: 'legal_information_plugin',
  },
  {
    pluginId: 15,
    icon: '/media/plugins/jstree/phonepe.png',
    name: 'Phone Pay',
    type: 'Payment',
    description: 'Edit Phone Pay Gateways',
    status: 'Active',
    path: 'phone_pay_payment_plugin',
  },
  {
    pluginId: 32,
    icon: '/media/plugins/jstree/cashfree.png',
    name: 'Cashfree (workway.pro)',
    type: 'Payment',
    description: 'Edit Cashfree Gateways',
    status: 'Active',
    path: 'cashfree_payment_plugin',
  },
  {
    pluginId: 38,
    icon: '/media/plugins/jstree/cashfree.png',
    name: 'Cashfree UPI (funbun.in)',
    type: 'Payment',
    description: 'Its Dyanamic Gateway we are using in funbun.in ai website to get instant payment',
    status: 'Active',
    path: 'cashfree_upi_payment_plugin',
  },
  {
    pluginId: 42,
    icon: '/media/plugins/jstree/cashfree.png',
    name: 'Cashfree YD (funbun.co.in)',
    type: 'Payment',
    description: 'Dynamic Cashfree gateway for Yourdworld platform to get instant payment',
    status: 'Active',
    path: 'cashfree_yd_payment_plugin',
  },
  {
    pluginId: 43,
    icon: '/media/plugins/jstree/cashfree.png',
    name: 'Cashfree DP (desiproduct.in)',
    type: 'Payment',
    description: 'Dynamic Cashfree gateway for Desi Product platform to get instant payment',
    status: 'Active',
    path: 'cashfree_dp_payment_plugin',
  },
  {
    pluginId: 46,
    icon: '/media/plugins/jstree/ip.png',
    name: 'Instantpaisa',
    type: 'Payment',
    description: 'Instantpaisa Payment Gateway',
    status: 'Active',
    path: 'instantpaisa_payment_plugin',
  },
  {
    pluginId: 18,
    icon: '/media/plugins/jstree/razorpay.png',
    name: 'Razor Pay',
    type: 'Payment',
    description: 'Edit Razor Pay Gateways',
    status: 'Active',
    path: 'razor_pay_payment_plugin',
  },
  {
    pluginId: 44,
    icon: '/media/plugins/jstree/payu.jpg',
    name: 'PayU',
    type: 'Payment',
    description: 'Edit PayU Gateways',
    status: 'Active',
    path: 'payu_payment_plugin',
  },
  {
    pluginId: 45,
    icon: '/media/plugins/jstree/payu.jpg',
    name: 'PayU Fun YD',
    type: 'Payment',
    description: 'Dynamic PayU gateway for Fun YD platform to get instant payment',
    status: 'Active',
    path: 'payufunyd_payment_plugin',
  },
  {
    pluginId: 19,
    icon: '/media/plugins/jstree/folder.webp',
    name: 'Folder Structure',
    type: 'Software',
    description: 'Edit Folder Size in Folder Structure',
    status: 'Active',
    path: 'folder_structure_plugin',
  },
  {
    pluginId: 20,
    icon: '/media/plugins/jstree/fakeusers.jpg',
    name: 'Anonymous User Interaction',
    type: 'Software',
    description:
      'Gives life to your ONLINE fake users, visiting and liking real users after their visit or like them',
    status: 'Active',
    path: 'user_interaction_plugin',
  },
  {
    pluginId: 21,
    icon: '/media/plugins/jstree/withdrawal.jpg',
    name: 'Withdrawal',
    type: 'Premium Plugin',
    description: 'Allow users to convert credits into real money',
    status: 'Active',
    path: 'withdrawal_plugin',
  },
  {
    pluginId: 22,
    icon: '/media/plugins/jstree/smtp.png',
    name: 'SMTP config',
    type: 'Tools',
    description: 'you can change dynamically configuration of smtp ',
    status: 'Active',
    path: 'smtp_plugin',
  },
  {
    pluginId: 26,
    icon: '/media/plugins/jstree/notification.png',
    name: 'Notification',
    type: 'Tools',
    description: 'Customize your Notifications',
    status: 'Active',
    path: 'notification_plugin',
  },
  // {
  //   pluginId: 28,
  //   icon: '/media/plugins/jstree/smtp.jpg',
  //   name: 'Moderator Level System',
  //   type: 'Tools',
  //   description: 'Customize Moderator Level System',
  //   status: 'Active',
  //   path: 'moderator_level_system',
  // },
  {
    pluginId: 9,
    icon: '/media/plugins/jstree/videocall.jpg',
    name: 'Videochat & Agora',
    type: 'Software',
    description: 'Peer to peer videocalling ',
    status: 'Active',
    path: 'videocall_plugin',
  },
  {
    pluginId: 30,
    icon: '/media/plugins/jstree/videocall.jpg',
    name: 'Currency Rate',
    type: 'Tools',
    description: 'Currency Rate in USD',
    status: 'Active',
    path: 'currency_rate_plugin',
  },
  {
    pluginId: 31,
    icon: '/media/plugins/jstree/wasabi.jpg',
    name: 'Storage And Backup Setting',
    type: 'Tools',
    description: 'Customize your Storage And Backup Setting',
    status: 'Active',
    path: 'storage_plugin',
  },
  {
    pluginId: 33,
    icon: '/media/plugins/jstree/avatar.png',
    name: 'Avatar Setting',
    type: 'Software',
    description: 'Customize and manage your site default avatars',
    status: 'Active',
    path: 'avatar_setting_plugin',
  },
  {
    pluginId: 34,
    icon: '/media/plugins/jstree/daily_reward.png',
    name: 'Daily Reward System',
    type: 'Tools',
    description: 'Configure and manage daily rewards for users',
    status: 'Active',
    path: 'daily_reward_plugin',
  },
  {
    pluginId: 35,
    icon: '/media/plugins/jstree/videocall.jpg',
    name: 'Leaderboard & Video Play',
    type: 'Software',
    description: 'Configure leaderboard and video playback settings',
    status: 'Active',
    path: 'leaderboard_video_play_plugin',
  },
  {
    pluginId: 36,
    icon: '/media/plugins/jstree/videocall.jpg',
    name: 'Audiochat',
    type: 'Software',
    description: 'Peer to peer audiocalling ',
    status: 'Active',
    path: 'audiochat_plugin',
  },
  {
    pluginId: 37,
    icon: '/media/plugins/jstree/cashfree.png',
    name: 'Dynamic Payment Gateway',
    type: 'Payment',
    description: 'Manage dynamic payment gateways with custom icons and settings.',
    status: 'Active',
    path: 'dynamic_payment_gateway_plugin',
  },
  {
    pluginId: 39,
    icon: '/media/plugins/jstree/videocall.jpg',
    name: 'Random Audio Video Call',
    type: 'Software',
    description: 'Configure settings for random audio and video calling',
    status: 'Active',
    path: 'random_audio_video_call',
  },
  {
    pluginId: 40,
    icon: '/media/plugins/jstree/rewards.jpg',
    name: 'Random Audio Videocall Review Suggestions',
    type: 'Software',
    description: 'Manage star-wise review suggestions and review popup settings for random calls',
    status: 'Active',
    path: 'random_call_suggestions',
  },
  {
    pluginId: 41,
    icon: '/media/plugins/jstree/withdrawal.jpg',
    name: 'Withdrawal Payment Methods',
    type: 'Premium Plugin',
    description: 'Customize dynamic withdrawal payment methods, icons, field configurations, and verification switches',
    status: 'Active',
    path: 'withdrawal_payment_methods_plugin',
  },
  {
    pluginId: 47,
    icon: '/media/plugins/jstree/verification.jpg',
    name: 'Voice Verification',
    type: 'Software',
    description: 'Allow users to verify their profile by voice',
    status: 'Active',
    path: 'voice_verification_plugin',
  },
  {
    pluginId: 48,
    icon: '/media/plugins/jstree/withdrawal.jpg',
    name: 'Payout Settings',
    type: 'Premium Plugin',
    description: 'Configure and manage auto/manual payout gateways',
    status: 'Active',
    path: 'payout_plugin',
  },
]

export default PluginData
